import * as React from 'react';
import classname from 'classnames';

import './index.scss';

export interface BaseToolBarGroupConfig {
  key: string;
  title?: React.ReactNode;
  className?: string;
  content: React.ReactNode;
}

interface BaseToolBarProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  role?: React.AriaRole;
  ariaLabel?: string;
  groups: BaseToolBarGroupConfig[];
  groupClassName?: string;
  titleClassName?: string;
  dividerClassName?: string;
  showDividers?: boolean;
  children?: React.ReactNode;
}

const BaseToolBar: React.FC<BaseToolBarProps> = ({
  className,
  orientation = 'horizontal',
  role = 'toolbar',
  ariaLabel,
  groups,
  groupClassName,
  titleClassName,
  dividerClassName,
  showDividers = false,
  children,
}: BaseToolBarProps) => {
  return (
    <div
      className={classname('tool-bar', `tool-bar--${orientation}`, className)}
      role={role}
      aria-label={ariaLabel}
    >
      {groups.map((group, idx) => (
        <React.Fragment key={group.key}>
          <div className={classname('tool-bar-group', groupClassName, group.className)}>
            {group.title ? (
              <div className={classname('tool-bar-group-title', titleClassName)}>{group.title}</div>
            ) : null}
            {group.content}
          </div>
          {showDividers && idx < groups.length - 1 ? (
            <div className={classname('tool-bar-divider', dividerClassName)} />
          ) : null}
        </React.Fragment>
      ))}
      {children}
    </div>
  );
};

export default BaseToolBar;
